import script from "./PremiumStub.vue?vue&type=script&setup=true&lang=js"
export * from "./PremiumStub.vue?vue&type=script&setup=true&lang=js"

import "./PremiumStub.vue?vue&type=style&index=0&id=6cd9fe02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cd9fe02"]])

export default __exports__